import React from 'react';

import { Button, forwardRef, useStyleConfig } from '@chakra-ui/react';

import { ActionButtonProps } from './types';

const ActionButton = forwardRef<ActionButtonProps, 'button'>(
  ({ size, ...props }, ref) => {
    const styles = useStyleConfig('ActionButton', { ...props });

    return (
      <Button
        ref={ref}
        __css={styles}
        iconSpacing={props?.children ? '2' : '0'}
        {...props}
      />
    );
  }
);

ActionButton.displayName = 'ActionButton';
export { ActionButton };
